import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FormField } from '../FormField';
export const NewsLetterField = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    return (_jsx(FormField, { name: "newsletter", children: (_a) => {
            var _b = _a.fieldProps, { ref } = _b, fieldProps = __rest(_b, ["ref"]), { error } = _a;
            return (_jsx(Checkbox, Object.assign({}, fieldProps, { id: fieldProps.name, name: fieldProps.name, label: t('checkout.personal.details.newsletter.subscribe'), testId: fieldProps.name, value: fieldProps.value, checked: fieldProps.value, error: error })));
        } }));
};
